<script>
	import { onMount } from 'svelte';
	import { theme } from './stores.js';

	import Header from './components/Header.svelte'
	import LiveData from './components/LiveData.svelte'
	import Charts from './components/Charts.svelte'
	import Contacts from './components/Contacts.svelte'
	import PostSection from './components/PostSection.svelte'

	function toggleTheme()
	{
		if($theme == 'light') {
			window.document.body.classList.add('dark-mode')
			$theme = 'dark';
		} else {
			window.document.body.classList.remove('dark-mode')
			$theme = 'light';
		}	
	}

	onMount(() => {
		if($theme == 'dark') window.document.body.classList.add('dark-mode')
	})

</script>

<main>
	<Header on:toggleTheme={toggleTheme}/>
	<div class="container">
		<LiveData/>
		<Charts/>
		<!-- <div class="maintenance">
			We are doing maintenance work on the server hosting the website database.<br/>
			Charts and statistics will be back soon.
		</div> -->
		<Contacts/>
		<PostSection/>
	</div>
</main>


<style>

	.container {
  		width: min(95%, 70rem);		/* 62.5rem -> 1000px,  70rem -> 1200px*/
  		margin-inline: auto;
		text-align: center;
	}
	
	.maintenance {
        border: 1px solid var(--clr-foreground-300);
        border-radius: 8px;
        text-align: center;
        padding-top: 5em;
        padding-bottom: 5em;
        padding-inline: 2.5em;
        word-wrap: break-word;
        font-size: 1em;
    }

</style>